
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Cars() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('');

  const transactionTypes = [
    { id: 'for-sale', name: 'للبيع', icon: 'ri-price-tag-3-line', count: '18 مزاد' },
    { id: 'for-rent', name: 'للإيجار', icon: 'ri-calendar-line', count: '4 مزاد' },
    { id: 'wanted', name: 'مطلوب', icon: 'ri-search-line', count: '2 مزاد' },
    { id: 'exchange', name: 'للبدل', icon: 'ri-exchange-line', count: '0 مزاد' }
  ];

  const carCategories = [
    { id: 'luxury', name: 'سيارات فاخرة', count: '12 مزاد' },
    { id: 'sports', name: 'سيارات رياضية', count: '8 مزاد' },
    { id: 'classic', name: 'سيارات كلاسيكية', count: '3 مزاد' },
    { id: 'suv', name: 'سيارات دفع رباعي', count: '6 مزاد' }
  ];

  const featuredCars = [
    {
      id: 1,
      title: 'لامبورغيني أفينتادور 2022',
      price: '850,000 ر.ق',
      year: '2022',
      mileage: '5,000 كم',
      timeLeft: '2:45:26',
      bidders: 12,
      image: 'https://www.soumqatar.com/uploads/cars/lamborghini-aventador-2022.jpg',
      isLive: true
    },
    {
      id: 2,
      title: 'مرسيدس S-Class 2023',
      price: '420,000 ر.ق',
      year: '2023',
      mileage: '2,000 كم',
      timeLeft: '1:30:15',
      bidders: 8,
      image: 'https://www.soumqatar.com/uploads/cars/mercedes-s-class-2023.jpg',
      isLive: true
    },
    {
      id: 3,
      title: 'بورش 911 تيربو 2021',
      price: '380,000 ر.ق',
      year: '2021',
      mileage: '8,500 كم',
      timeLeft: '4:20:08',
      bidders: 15,
      image: 'https://www.soumqatar.com/uploads/cars/porsche-911-turbo-2021.jpg',
      isLive: false
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: 'Cairo, sans-serif' }}>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-black/90 backdrop-blur-sm z-50 px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <button 
              onClick={() => navigate('/')}
              className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center ml-3 border border-gray-700/50"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <div>
              <h1 className="text-lg font-bold">السيارات</h1>
              <p className="text-xs text-gray-400">24 مزاد نشط</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 space-x-reverse">
            <button className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center border border-gray-700/50">
              <i className="ri-search-line text-xl"></i>
            </button>
            <button className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center border border-gray-700/50">
              <i className="ri-filter-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      <main className="pt-16 pb-6">
        {/* Transaction Types */}
        <div className="px-4 py-6">
          <h3 className="text-lg font-semibold mb-4">نوع المعاملة</h3>
          <div className="grid grid-cols-2 gap-3">
            {transactionTypes.map((type) => (
              <button
                key={type.id}
                onClick={() => setSelectedType(type.id)}
                className={`p-4 rounded-xl text-center transition-colors ${
                  selectedType === type.id 
                    ? 'bg-yellow-400 text-black' 
                    : 'bg-gray-900 hover:bg-gray-800'
                }`}
              >
                <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center">
                  <i className={`${type.icon} text-2xl`}></i>
                </div>
                <h4 className="font-medium text-sm mb-1">{type.name}</h4>
                <p className={`text-xs ${selectedType === type.id ? 'text-black/70' : 'text-gray-400'}`}>
                  {type.count}
                </p>
              </button>
            ))}
          </div>
        </div>

        {/* Car Categories */}
        <div className="px-4 mb-6">
          <h3 className="text-lg font-semibold mb-4">فئات السيارات</h3>
          <div className="grid grid-cols-2 gap-3">
            {carCategories.map((category) => (
              <button
                key={category.id}
                className="bg-gray-900 rounded-xl p-4 text-center hover:bg-gray-800 transition-colors"
              >
                <h4 className="font-medium text-sm mb-1">{category.name}</h4>
                <p className="text-xs text-gray-400">{category.count}</p>
              </button>
            ))}
          </div>
        </div>

        {/* Featured Cars */}
        <div className="px-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold">السيارات المميزة</h3>
            <button className="text-yellow-400 text-sm font-medium">عرض الكل</button>
          </div>
          
          <div className="space-y-4">
            {featuredCars.map((car) => (
              <div key={car.id} className="bg-gray-900 rounded-xl overflow-hidden">
                <div className="relative">
                  <img
                    src={car.image}
                    alt={car.title}
                    className="w-full h-48 object-cover object-top"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      const fallbackImages: { [key: number]: string } = {
                        1: 'https://public.readdy.ai/ai/img_res/b1d774a89d1b11cd94dac106a659afbc.jpg',
                        2: 'https://readdy.ai/api/search-image?query=Luxury%20Mercedes%20S-Class%202023%20sedan%2C%20premium%20automotive%20photography%2C%20elegant%20design%2C%20high-end%20vehicle%2C%20professional%20car%20photography%2C%20sophisticated%20lighting%2C%20modern%20luxury%20automobile%2C%20executive%20car&width=343&height=200&seq=car2&orientation=landscape',
                        3: 'https://readdy.ai/api/search-image?query=Luxury%20Porsche%20911%20Turbo%202021%20sports%20car%2C%20premium%20automotive%20photography%2C%20dynamic%20design%2C%20high-performance%20vehicle%2C%20professional%20car%20photography%2C%20sophisticated%20lighting%2C%20modern%20sports%20automobile%2C%20racing%20heritage&width=343&height=200&seq=car3&orientation=landscape'
                      };
                      target.src = fallbackImages[car.id] || fallbackImages[1];
                    }}
                  />
                  
                  {car.isLive && (
                    <div className="absolute top-3 right-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                      <div className="w-1.5 h-1.5 bg-white rounded-full ml-1 animate-pulse"></div>
                      مباشر
                    </div>
                  )}
                  
                  <button className="absolute bottom-3 left-3 w-8 h-8 bg-black/70 rounded-full flex items-center justify-center">
                    <i className="ri-heart-line text-white"></i>
                  </button>
                </div>
                
                <div className="p-4">
                  <h4 className="font-semibold mb-2">{car.title}</h4>
                  
                  <div className="flex items-center justify-between mb-3 text-sm text-gray-400">
                    <span>سنة الصنع: {car.year}</span>
                    <span>المسافة: {car.mileage}</span>
                  </div>
                  
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <p className="text-xs text-gray-400 mb-1">السعر الحالي</p>
                      <p className="text-lg font-bold text-yellow-400">{car.price}</p>
                    </div>
                    
                    {car.isLive && (
                      <div className="text-left">
                        <p className="text-xs text-gray-400 mb-1">الوقت المتبقي</p>
                        <p className="text-sm font-mono text-white">{car.timeLeft}</p>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <i className="ri-user-line text-gray-400 ml-1"></i>
                      <span className="text-sm text-gray-400">{car.bidders} مزايد</span>
                    </div>
                    <button className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold text-sm">
                      {car.isLive ? 'زايد الآن' : 'عرض التفاصيل'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
